export class InvoiceChartType {
  constructor(
    public code: string,
    public threshold: string
  ) { }
}
